import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';
//import { HolderGroupsPageService } from "../../../../services";

export const ActualPoliciesPageContext = React.createContext({});
export let actualPoliciesPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMActualPoliciesGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  actualPoliciesPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(actualPoliciesPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    actualPoliciesPageMachine,
    actualPoliciesPageState: state,
    actualPoliciesPageSend: send,
  };
};
